import Vue from 'vue'

export default {
  setFiltersData(state, { key, value }) {
    Vue.set(state.filtersData, key, value)
  },

  setFiltersConfig(state, { key, value }) {
    Vue.set(state.filtersConfig, key, value)
  },
}
